import React, { useEffect } from 'react';
import { sendTrackingInfo, ModalCreditsOptions } from '@panel/commons';
import { useTranslation } from 'react-i18next';

function FreemiumFlowOffToOnCreditsYesFreeNo(props) {
  const { onClickCancel, onClickAction, onClickSelect, plans, defaultPlan, isInmobiliaria } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const txt = `Republicar Aviso_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`;
    sendTrackingInfo('Mis avisos', txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickAction = e => {
    const txt = `Republicar Aviso Con credito_Usar Creditos_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickAction(e);
  };

  const handleClickCancel = () => {
    const txt = `Republicar Aviso Con credito_Cancelar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickCancel();
  };

  return (
    <ModalCreditsOptions
      onClickAction={e => handleClickAction(e)}
      onClickCancel={handleClickCancel}
      onClickSelect={onClickSelect}
      onClickOutside={handleClickCancel}
      plans={plans}
      defaultPlan={defaultPlan}
      title={t('panel.modal.FreemiumFlowOffToOnCreditsYesFreeNo.title')}
      subTitle={t('panel.modal.FreemiumFlowOffToOnCreditsYesFreeNo.subtitle')}
      ctaCancel={t('panel.modal.cta.cancel')}
      ctaOk={t('panel.modal.cta.useCredits')}
    />
  );
}

export { FreemiumFlowOffToOnCreditsYesFreeNo };
